module.exports = __webpack_public_path__ + "img/logo.ebe7150b.svg";